package scenes

import assets.*
import b2d.*
import com.github.quillraven.fleks.*
import com.soywiz.klock.*
import com.soywiz.korge.box2d.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.view.*
import com.soywiz.korge.view.Camera
import com.soywiz.korge.view.camera.*
import com.soywiz.korim.color.*
import com.soywiz.korio.async.*
import component.*
import input.*
import io.ktor.client.*
import io.ktor.client.plugins.websocket.*
import io.ktor.http.*
import io.ktor.websocket.*
import models.*
import models.PlayerData
import network.*
import org.jbox2d.common.*
import scenes.test.*
import system.*
import system.network.*
import utils.*

class MultiplayerRunScene : Scene() {
    private val animations = mutableMapOf<String, SpriteAnimation>()

    private lateinit var physicWorldComponent: Box2dWorldComponent
    private val physicWorld: org.jbox2d.dynamics.World = org.jbox2d.dynamics.World(Vec2(0f, 10f)).apply {
        customScale = 100.0
    }

    private val client = HttpClient {
        install(WebSockets) {
//            pingInterval = 5
            maxFrameSize = Long.MAX_VALUE
        }
    }

    private val wsSessionAdapter = WsSessionAdapter()
    private lateinit var networkInputSystem: NetworkInputSystem
    private lateinit var networkOutputSystem: NetworkOutputSystem
    private lateinit var playerSpawnSystem: NetworkPlayerSpawnSystem
    private lateinit var otherPlayersSpawnSystem: NetworkOtherPlayersSpawnSystem
    private lateinit var otherPlayerDisconnectedSystem: OtherPlayerDisconnectedSystem
    private lateinit var deadReconSystem: DeadReconSystem
    private lateinit var physicSnapshotSystem: PhysicSnapshotStateSystem

    override suspend fun SContainer.sceneInit() {
        println("MultiplayerRunScene sceneInit")

        // load assets

//        physicWorldComponent = getOrCreateBox2dWorld().apply {
//            world.gravity = Vec2(0f, 10f)
//            world.customScale = GameDimensions.PPM.toDouble()
//        }

        loadPlayerAnimation("characters/ninja_frog").forEach {
            animations["ninja-frog-${it.key.name}"] = it.value
        }
    }

    suspend fun connect(adapter: WsSessionAdapter) {
        client.ws(
            method = HttpMethod.Get,
//            host = "192.168.0.4",
            host = "127.0.0.1",
            port = 8081,
            path = "/game"
        ) {
            adapter.initialize(this)
            for (frame in incoming) {
                when (frame) {
                    is Frame.Binary -> {
                        val bytes = frame.readBytes()
                        val packet = ObjectMapper.parseBytes<Packet>(bytes)
                        when (packet.data) {
                            is SessionInfo -> {
                                val sessionInfo = packet.data as SessionInfo
                                adapter.id = sessionInfo.player.id
                                physicSnapshotSystem.setSequence(sessionInfo.serverStartTime)
                                playerSpawnSystem.firstConnect(sessionInfo)
                                sessionInfo.otherPlayers.forEach { otherPlayer ->
                                    otherPlayersSpawnSystem.respawnPlayer(otherPlayer)
                                }
                            }

                            is PlayerData -> {
                                val newPLayer = packet.data as PlayerData
                                otherPlayersSpawnSystem.respawnPlayer(newPLayer)
                            }

                            is PlayerPhysicStates -> {
                                val states = packet.data as PlayerPhysicStates
//                                networkInputSystem.receivePhysicStates(states)
                                deadReconSystem.addSnapshot(states)
                            }

                            is PlayerRemoved -> {
                                val playerToRemove = packet.data as PlayerRemoved
                                otherPlayerDisconnectedSystem.onPlayerDisconnect(playerToRemove.id)
                            }

                            else -> {}
                        }
                    }

                    else -> {}
                }
            }
        }
    }

    override suspend fun SContainer.sceneMain() {
        println("MultiplayerRunScene sceneMain")

        val camera = Camera()
        val cameraContainer = cameraContainer(width, height, clip) {
            camera.addTo(this) {
//                WorldObjectFactory.loadLevel(physicWorld, this)
            }
        }

        val keyboardControllerView = solidRect(1, 1, Colors.TRANSPARENT_BLACK)
        val keyboardController = KeyboardController(keyboardControllerView)
        keyboardControllerView.addComponent(keyboardController)

        val pingText = text("ping: 0").position(2, 2)

        val world = world {
            injectables {
                add(SCENE_CONTAINER, this@sceneMain)
                add(physicWorld)
                add(keyboardController)
                add(cameraContainer)
                add(camera)
            }

            components {
                onAdd(PhysicComponent, PhysicComponent.onAddPhysic)
                onRemove(PhysicComponent, PhysicComponent.onRemovePhysic)
            }

            systems {
                // send input to server
                networkOutputSystem = NetworkOutputSystem()
                add(networkOutputSystem)

                otherPlayerDisconnectedSystem = OtherPlayerDisconnectedSystem()
                add(otherPlayerDisconnectedSystem)
                networkInputSystem = NetworkInputSystem()
                add(networkInputSystem)
                otherPlayersSpawnSystem = NetworkOtherPlayersSpawnSystem()
                add(otherPlayersSpawnSystem)


                deadReconSystem = DeadReconSystem()
                add(deadReconSystem)

                add(NetworkPhysicSyncSystem())

                // apply input to bodies
                add(PlayerControlSystem())

                playerSpawnSystem = NetworkPlayerSpawnSystem()
                add(playerSpawnSystem)

                add(Box2dStepSystem())

                physicSnapshotSystem = PhysicSnapshotStateSystem()
                add(physicSnapshotSystem)

                add(PlayerAnimationSystem())
                add(SpriteAnimationSystem(animations))

                add(NetworkInfoSystem(wsSessionAdapter, pingText))
                add(PhysicDebugSystem())
            }
        }

        val dt = 1 / 60f

        addFixedUpdater(60.timesPerSecond) {
            world.update(dt)
        }

        launch {
            connect(wsSessionAdapter)
        }

        launch {
            networkOutputSystem.readEvents {
                val bytes = ObjectMapper.writeAsByteArray(Packet(it))
//                println("out: $it")
                wsSessionAdapter.webSocketSession.send(bytes)
            }
        }
    }
}
